/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/** 设置/重置密码：至少8位，须含字母+数字；@、_ 等特殊符号可选 */
export const PASSWORD_PATTERN =
  /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@_!#$%^&*()+=.?~\-]{8,}$/

export const PASSWORD_FORMAT_MSG =
  '密码至少8位，须包含字母和数字，可含@、_等特殊符号'

export const PASSWORD_PLACEHOLDER =
  '至少8位，须含字母和数字，可含@、_等符号'

/**
 * @param {string} value
 * @returns {Boolean}
 */
export function isValidPassword(value) {
  return PASSWORD_PATTERN.test(String(value || ''))
}

/**
 * Element UI 表单校验器
 * @param {string} value
 * @param {Function} callback
 * @param {{ allowEmpty?: boolean }} options
 */
export function validatePasswordFormat(value, callback, options = {}) {
  const { allowEmpty = false } = options
  if (allowEmpty && !value) {
    callback()
    return
  }
  if (!value) {
    callback(new Error('请输入密码'))
    return
  }
  if (!isValidPassword(value)) {
    callback(new Error(PASSWORD_FORMAT_MSG))
    return
  }
  callback()
}
